



















































import Vue from 'vue'

export default Vue.extend({
  name: 'Menu',
  methods: {
    toggle () {
      this.visible = !this.visible
      this.$emit('scrollBody')
    },
    handleScroll () {
      this.scrolled = window.scrollY > 72
    }
  },
  data () {
    return {
      visible: false,
      scrolled: false
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
})
